<template>
  <div class="step-container scrollPosition">
    <div class="step-header">
      <h2 class="step-title">Zusammenfassung</h2>
      <p class="step-text">
        Wir sind fast fertig! Wir haben jetzt alle Informationen zur Bewertung
        Ihrer Immobilie.<br />Mit Klick auf Immobilien-Check berechnen, senden
        wir Ihnen ein E-Mail an <b>{{ fields.kundeEmail.value }}</b>
      </p>
    </div>
    <div class="step-body">
      <div class="d-inline-block mb-5">
        <CheckBox
          label="Ich stimme den <u>Nutzungsbedingungen</u> zu."
          v-model="fields.nutzungsbedingungen.value"
          @update:modelValue="validate('nutzungsbedingungen')"
          :state="fields.nutzungsbedingungen.state"
          class="mb-3"
          :class="{ 'pe-none': pending }"
        />
        <CheckBox
          label="Ich stimme den Gratis-Newsletter der s Bausparkasse erhalten"
          v-model="fields.newsletter.value"
          :class="{ 'pe-none': pending }"
        />
      </div>
      <button
        class="button m-auto mt-3 compute-check-btn"
        @click="computeCheck"
        :disabled="pending"
      >
        <span :class="{ invisible: pending }">Immobilien-Check berechnen</span>
        <div
          v-if="pending"
          class="spinner-overlay"
        >
          <PulseLoader color="white" />
        </div>
      </button>
    </div>
    <div class="step-footer">
      <div class="row">
        <div class="col-md-4 col-sm-4 text-start">
          <button
            class="back-btn"
            @click="goBack()"
            :disabled="pending"
          >
            Zurück
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataService from "@/services/DataService.js";
import CheckBox from "@/components/shared/CheckBox.vue";
import {
  getFromStorage,
  clearStorage,
  checkInvalidFields,
  containsInvalidFields,
  validateField,
  isSet,
getDataForBaugrundstueckEvaluation,
} from "@/utils.js";
export default {
  name: "baugrundstueck-step-5a",
  components: {
    CheckBox,
  },
  data() {
    return {
      fields: {
        kundeEmail: {},
        nutzungsbedingungen: {
          value: "false",
          validators: ["checked"],
        },
        newsletter: { value: "false" },
      },
      pending: false,
    };
  },
  methods: {
    goBack() {
      this.$router.push("/baugrundstueck-step-4");
    },
    async computeCheck() {
      checkInvalidFields(this.fields);
      if (!containsInvalidFields(this.fields)) {
        this.pending = true;
        const evalData = getDataForBaugrundstueckEvaluation();
        const response = await DataService.createBaugrundstueckEvaluation(evalData);
        if (response.status === 200) {
          if (isSet(this.fields.newsletter.value)) {
            await DataService.subscribeToNewsletter();
          }
          clearStorage();
          this.$router.push("/baugrundstueck-step-5b");
        } else {
          this.$router.push("/baugrundstueck-step-5c");
        }
      }
    },
    validate(name) {
      const field = this.fields[name];
      field.state = validateField(field.value, field.validators);
    },
  },
  mounted() {
    this.$emit("setStep", "baugrundstueck", 6);
    getFromStorage(this.fields);
  },
};
</script>
